import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation.ts";
import { usePoliciesQuery } from "@common/hooks/useSelectableItemQueries.ts";

export interface SystemPoliciesCreationFieldProps {
    selectedIds: Array<string>;
    onChange: (ids: Array<string>) => void;
    errorText?: string;
    disabled: boolean;
}

function SystemPoliciesCreationField(props: SystemPoliciesCreationFieldProps) {
    const { translateString } = useTranslation();
    const { data, isLoading } = usePoliciesQuery();

    const options = data?.map((item) => ({ id: item.id, name: item.name }));

    return (
        <DotLegalMultiSelect
            isLoading={isLoading}
            options={options}
            chosenOptions={props.selectedIds}
            onChange={props.onChange}
            placeholder={translateString("policies")}
            label={translateString("policies")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default SystemPoliciesCreationField;
